import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withOutboundLink } from 'LiveBoard/hocs'
import { SmartImage } from 'shared/UI/SmartImage'
import { CTA_AREAS, LINK_TYPES, LINK_TARGETS } from 'LiveBoard/components/shared/CallToAction/constants'
import snakeCase from 'lodash/snakeCase'

const Logo = ({
  config,
  onClick,
  tabIndex,
  onOpenOutboundLink,
  setOutboundUrlAttribute
}) => {
  useEffect(() => {
    config.link && setOutboundUrlAttribute(config.link)
  },[])

  const handleClick = (url) => {
    onClick()
    onOpenOutboundLink(
      url,
      LINK_TARGETS[LINK_TYPES.newTab],
      {
        area: snakeCase(CTA_AREAS.header)
      }
    )
  }

  return (
    <SmartImage
      config={config.image}
      alt={config.alt}
      className={`logo ${!config.link ? ' disabled' : ''}`}
      onClick={() => config.link && handleClick(config.link)}
      isImgTag={true}
      tabIndex={tabIndex} />
  )
}

Logo.propTypes = {
  config: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  onOpenOutboundLink: PropTypes.func,
  setOutboundUrlAttribute: PropTypes.func
}

export default withOutboundLink(Logo)